import { render } from "./IndividualInfoScience.vue?vue&type=template&id=70028221&scoped=true"
import script from "./IndividualInfoScience.vue?vue&type=script&lang=js"
export * from "./IndividualInfoScience.vue?vue&type=script&lang=js"

import "./IndividualInfoScience.vue?vue&type=style&index=0&id=70028221&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70028221"]])

export default __exports__